// @ts-nocheck
import moment from 'moment'

export default (date, time) => {
  const then = moment(date + 'T' + time, 'YYYY-MM-DDTHH:mm')
  const diff = then.diff()
  const fromNow = then.fromNow(true)
  return { isInPast: diff <= 0, fromNow }
}
